// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-control-step__arrow[data-v-6492398f]{align-content:right;transform:rotate(180deg)}.c-control-step__arrow[data-v-6492398f]:not(.is-open){transform:rotate(0)}", ""]);
// Exports
module.exports = exports;
